import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { BookablePeriods } from 'ha/services/apiV2/types/BookablePeriods';
import { APIV2_URL } from './constants';

interface Query {
  minimumStayMonths?: number;
}

export default (makeCall: MakeCall) => (listingId: number, query?: Query) =>
  makeCall<BookablePeriods>(
    'GET',
    `${APIV2_URL}/listing/${listingId}/bookable-periods`,
    {
      query,
    },
  );
